// eslint-disable-next-line import/prefer-default-export
export const errorDispatcher = (dispatch, message) => dispatch({ type: 'SET_APPLICATION_ERROR', payload: message });
